// Description: this service is used to add filters for STATIC tables
import { makeAutoObservable } from 'mobx';

export interface IAppTableFilters {
  isLoading: boolean;
  data: any;
  page: number;
  skip: number;
  take: number;
  filters: any[];
  addFilter: (filter: any) => void;
  setData: (data: any[]) => void;
  getData: () => any[];

  removeFilter: (filter: any) => void;
  getFilteredData: () => any[];
}

export type singleStaticFilterType = {
  id: string;
  type: 'textfields' | 'select' | 'radio' | 'date-range-separate-pickers';
  field: string;
  label: string;
  value: any;
  options?: { label: string; value: any }[];
  filteringFn?: (item: any, value: any) => boolean;
};

export class AppTableFilters implements IAppTableFilters {
  isLoading: boolean = false;
  data: any = [];
  page: number = 1;
  skip: number = 0;
  take: number = 10;
  filters: singleStaticFilterType[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data: any[]) => {
    this.data = data;
  };

  getData = () => {
    return this.data;
  };

  addFilter = (filter: singleStaticFilterType) => {
    const filterIndex = this.filters.findIndex((f) => f.id === filter.id);

    if (filterIndex === -1) {
      this.filters = [...this.filters, filter];
    } else {
      this.filters = this.filters.map((f) => {
        if (f.id === filter.id) {
          return filter;
        }
        return f;
      });
    }
  };

  removeFilter = (filter: singleStaticFilterType) => {
    const filterIndex = this.filters.findIndex((f) => f.id === filter.id);
    if (filterIndex !== -1) {
      this.filters = this.filters.filter((f) => f.id !== filter.id);
    }
  };

  getFilteredData = () => {
    if (!this.filters.length) return this.data;

    let filteredData = JSON.parse(JSON.stringify(this.data));

    this.filters.forEach(({ id, type, field, value, filteringFn }) => {
      if (filteringFn) {
        filteredData = filteredData.filter((item) => filteringFn(item, value));
        return;
      }

      if (type === 'textfields') {
        filteredData = filteredData.filter((item) => {
          if (field in item && item[field]?.toLowerCase()?.includes(value?.toLowerCase())) {
            return true;
          }
        });
      }

      if (type === 'select') {
        filteredData = filteredData.filter((item) => {
          if (field in item && item[field]?.toLowerCase()?.includes(value?.toLowerCase())) {
            return true;
          }
        });
      }

      if (type === 'radio') {
        filteredData = filteredData.filter((item) => {
          if (field in item && item[field] == value) {
            return true;
          }
        });
      }
    });

    return filteredData;
  };
}

export const CreateTextFilter = (
  appTableFiltersInstance: AppTableFilters,
  column: string,
  label: string,
  filteringFn?: (item: any, value: any) => boolean,
  valueConverter?: (value: any) => any) => {
  return {
    id: column,
    type: 'textfields',
    onApply: (value) => {
      if (value[column]) {
        appTableFiltersInstance.addFilter({
          id: column,
          type: 'textfields',
          label: `${label}: ${valueConverter ? valueConverter(value[column]) : value[column]}`,
          field: column,
          value: value[column],
          filteringFn
        });
      }
    },
    inputs: [
      {
        id: column,
        // this is the field inside the data object that should be used to filter the data
        field: column,
        label: label,
        value: '',
      }
    ]
  };
};
